import Vue from "vue";

export async function getUserByHash(context, [hash]) {
  try {
    const response = await Vue.axios({
      method: "GET",
      url: "/users/hash/" + hash,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response && response.status == 200 && response.data && response.data.user) {
      return response.data.user;
    } else {
      return null;
    }
  } catch (e) {
    return null;
  } finally {
  }
}

export async function getReservaByHash(context, [hash]) {
  try {
    const response = await Vue.axios({
      method: "GET",
      url: "/getReservaByHash?hash=" + hash,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    if (
      response &&
      response.status == 200 &&
      response.data &&
      response.data.data  
    ) {
      return response.data.data;
    } else {
      return null;
    }

  } catch (e) {
  } finally {
    context.commit("setLoading", false, { root: true });
  }
}


export async function confirmarPasajeros(context, [pasajeros, reserva_id, version_pasajeros]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: "/confirmarPasajeros"  ,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: {
        pasajeros,
        reserva_id,
        version_pasajeros,
      },
    });
    if (
      response &&
      response.status == 200 &&
      response.data 
    
    ) {
      return response;
    } else {
      return null;
    }

  } catch (e) {
  } finally {
    context.commit("setLoading", false, { root: true });
  }
}


export async function obtenerUrlPago(context, [reserva_id]) {
  try {
    const response = await Vue.axios({
      method: "GET",
      url: "/obtenerUrlPago?reserva_id=" + reserva_id,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    if (
      response &&
      response.status == 200 &&
      response.data 
    
    ) {
      return response.data;
    } else {
      return null;
    }

  } catch (e) {
  } finally {
   
  }
}

export async function enviarConsulta(context, [reserva_id, consulta]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: "/enviar-consulta",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: {
        reserva_id,
        consulta,
      },
    });
    if (
      response &&
      response.status == 200 &&
      response.data
    ) {
      return response.data;
    } else {
      return null;
    }
  } catch (e) {
  } finally {
   
  }
}

export async function solicitarRegistroAgencia(context, [nombre, responsable, email, telefono, mensaje]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: "/solicitud-registro-agencia",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: {
        nombre,
        responsable,
        email,
        telefono: telefono || "",
        mensaje: mensaje || "",
      },
    });

    if (response && response.status == 201 && response.data) {
      return response.data;
    } else {
      return null;
    }
  } catch (e) {
    return null;
  } finally {
  }
}

export async function cambiarCredencialAgencia(context, [hash, password, password_confirmation]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: "/cambiar-credencial-agencia",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: {
        hash,
        password,
        password_confirmation,
      },
    });

    if (response && response.status == 200 && response.data) {
      return response.data;
    } else {
      return null;
    }
  } catch (e) {
    return null;
  } finally {
  }
}
